import ModalComponent from 'components/Common/Modal';
import DescriptionTinyEditor from 'components/Dashboard/UserContent/ui/DescriptionTinyEditor';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import { store } from 'components/Store';
import { useCreatePrompt } from 'components/WritingAssistant/ui/Create';
import useCustomInstructionsFunctions from 'components/WritingAssistant/ui/useCustomInstructionsFunctions';
import { useContext, useEffect, useRef, useState } from 'react';

const CustomInstructionsPopup = ({ isOpenState }) => {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { team } = state;

  const { aiAssistantConstituentResponseInstructions } = team ?? {};

  const { isOpen, setIsOpen } = isOpenState ?? {};

  const [loadingUpdateInstructions, setLoadingUpdateInstructions] = useState(false);
  const [currentInstructions, setCurrentInstructions] = useState();
  const { updateCustomInstructions, removeCustomInstructions } = useCustomInstructionsFunctions();
  const { normalizeEditorValue } = useCreatePrompt();

  useEffect(() => {
    setCurrentInstructions(aiAssistantConstituentResponseInstructions);
  }, [team]);

  const descriptionIsChanged = currentInstructions !== aiAssistantConstituentResponseInstructions;

  const handleClick = async () => {
    try {
      setLoadingUpdateInstructions(true);
      const text = currentInstructions;
      const remove = normalizeEditorValue(text) === '';
      let response;
      if (remove) {
        response = await removeCustomInstructions({});
      } else {
        response = await updateCustomInstructions({
          instructions: text,
        });
      }
      if (!!response) {
        dispatch({
          type: 'MODIFY_SECTION',
          parameter: 'team',
          value: { ...team, aiAssistantConstituentResponseInstructions: currentInstructions },
        });
        if (remove) {
          createNotification('success', 'Instructions have been removed');
        } else {
          createNotification(
            'success',
            `Instructions ${!!aiAssistantConstituentResponseInstructions ? 'updated' : 'saved'}`
          );
        }
        setIsOpen(false);
      }
      setLoadingUpdateInstructions(false);
    } catch (error) {
      setLoadingUpdateInstructions(false);
    }
  };

  const editorRef = useRef();
  const editorToEdit = useRef();

  return (
    <ModalComponent
      maxWidth={850}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      overlayClassName={'react-modal-overlay modal-close-position-adjustment'}
    >
      <div className={`tailor-summaries-modal`}>
        <p className='popup-header px-3 px-lg-5 flex-centered'>
          <span>Custom instructions</span>
        </p>

        <div className='separator' />
        <div className='popup-body p-3 px-lg-5 pb-lg-2'>
          <div>
            <p>
              Custom instructions are applied to every response your team generates using the AI assistant. They let you
              set your preferred tone and wording, define what information to include or avoid, add key constituency
              context, and specify preferred formats.
            </p>
            <div className='position-relative'>
              <div className='influence-description position-relative'>
                <DescriptionTinyEditor
                  ref={editorRef}
                  editorToEdit={editorToEdit}
                  value={currentInstructions}
                  setValue={(value) => setCurrentInstructions(value)}
                  placeholder='Add instructions'
                  addVerticalScroll
                  customButtons={`bold | italic | numlist | bullist`}
                  additionalStyles={
                    'p {margin: 0; line-height: 1.4;} .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks) {cursor: text;}'
                  }
                  maxHeight={300}
                />
              </div>
              {/* <textarea
                ref={textAreaRef}
                value={currentInstructions}
                rows={7}
                className='input-empty w-100 border border-grey rounded-sm p-3'
                style={{ resize: 'none' }}
                onChange={(e) => {
                  setCurrentInstructions(e.target.value);
                }}
              ></textarea> */}
            </div>
            <div
              className={`pb-3 tailor-summary-action-container flex-centered justify-content-end
              }  mt-3`}
            >
              <div className='flex-centered pt-1'>
                <button
                  className={`action-button general-button px-4 filter-action-button update-button`}
                  onClick={() => {
                    handleClick();
                  }}
                  disabled={
                    !descriptionIsChanged ||
                    loadingUpdateInstructions ||
                    (aiAssistantConstituentResponseInstructions === null && currentInstructions?.length === 0)
                  }
                >
                  {loadingUpdateInstructions && <i className='fas fa-spinner fa-spin mx-2 d-inline-block-centered' />}
                  <span>{!!aiAssistantConstituentResponseInstructions ? 'Update' : 'Save'} instructions</span>
                </button>
              </div>
            </div>
          </div>

          <div className='mb-2 flex-centered justify-content-end'>
            <button className='general-button delete-button px-4 mr-3 py-1' onClick={() => setIsOpen(false)}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </ModalComponent>
  );
};

export default CustomInstructionsPopup;
